import React from "react";
import LibraryActions from "../../../../actions/library-actions";
var Isvg = require("../../../../../vendor/react-inlinesvg");

import { VstInput, VstInputGroup, VstButton, VstLoader } from "vstui";

class AccessCodeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      accessCode: undefined,
      courseKey: undefined,
      waiting: false,
      error: null
    };
  }

  componentDidMount() {
    Jigsaw.getAllAccessCodes(response => {
      if (response.code === 200) {
        const license = response.data.licenses.find(
          l => l.isbn === this.props.isbn
        );
        const ancillaries = license && license.ancillaries;
        const ancillary = ancillaries && ancillaries.pop();
        this.setState({ ancillary });
      }
    });
  }

  nextStep(state, props) {
    return { step: state.step + 1 };
  }

  reveal() {
    this.setState({ waiting: true });
    Jigsaw.redeemAncillary(this.props.isbn, response => {
      if (response.code === 200 && response.data.success) {
        LibraryActions.loadAccessCodes();
        this.setState(state => ({
          step: state.step + 1,
          accessCode: response.data.code,
          courseKey: response.data.courseKey,
          waiting: false
        }));
      } else {
        this.setState({ waiting: false, error: response.data });
      }
    });
  }

  copyToClipboard(text) {
    Fraction.Helpers.copyText(text);
    Fraction.Helpers.toast(i18n.t("eresources.code-copied"));
  }

  visitWebSite() {
    Fraction.Helpers.Locations.safeRedirect(
      this.state.ancillary.href,
      "_blank"
    );
  }

  initialInfo() {
    return (
      <div id="initial-info">
        <div className="process-description">
          <p>{i18n.t("eresources.reveal-process-desc")}...</p>

          <div className="steps">
            <div className="step">
              <div className="step-icon">
                <Isvg src="/img/eresources-reveal.svg" />
              </div>
              <div className="step-info">
                <div className="step-text">
                  1. {i18n.t("eresources.reveal-step-1")}
                </div>
              </div>
            </div>
            <div className="step">
              <div className="step-icon">
                <Isvg src="/img/eresources-visit.svg" />
              </div>
              <div className="step-info">
                <div className="step-text">
                  2. {i18n.t("eresources.reveal-step-2")}
                </div>
              </div>
            </div>
            <div className="step">
              <div className="step-icon">
                <Isvg src="/img/eresources-register.svg" />
              </div>
              <div className="step-info">
                <div className="step-text">
                  <span>3. {i18n.t("eresources.reveal-step-3")}</span>
                  <p className="step-note">
                    {i18n.t("eresources.reveal-step-3-info")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-info">
            {window.toHTML(
              i18n.t("eresources.reveal-process-info", {
                isbn: this.props.isbn
              })
            )}
          </div>
        </div>
        <div className="footer-actions">
          <button onClick={() => this.setState(this.nextStep)}>
            {i18n.t("base.continue")}
          </button>
        </div>
      </div>
    );
  }

  revealAccessCode() {
    const policyLink =
      Fraction.Brand.ReturnPolicy.url ||
      i18n.t("locations.zendesk-return-privacy");
    return (
      <div id="reveal-access-code">
        <div className="step-info">
          <Isvg src="/img/eresources-reveal.svg" key="reveal-img" />
          <p>
            {window.toHTML(
              i18n.t("eresources.reveal-warning", { link: policyLink })
            )}
          </p>
        </div>

        <div className="footer-actions">
          <button onClick={() => this.reveal()}>
            {i18n.t("eresources.reveal-access-code")}
          </button>
        </div>
      </div>
    );
  }

  showAccessCode() {
    return (
      <div id="show-access-code">
        <div className="step-info">
          <Isvg src="/img/eresources-visit.svg" key="register-img" />
          <div className="copy-inputs">
            <VstInputGroup label={i18n.t("eresources.access-code")}>
              <VstInput type="text" value={this.state.accessCode} readOnly />
              <VstInputGroup.Button>
                {Fraction.Helpers.copyEnabled && (
                  <VstButton
                    onClick={() => this.copyToClipboard(this.state.accessCode)}
                  >
                    {i18n.t("base.copy")}
                  </VstButton>
                )}
              </VstInputGroup.Button>
            </VstInputGroup>
            {this.state.courseKey && (
              <VstInputGroup label={i18n.t("eresources.course-key")}>
                <VstInput type="text" value={this.state.courseKey} readOnly />
                <VstInputGroup.Button>
                  {Fraction.Helpers.copyEnabled && (
                    <VstButton
                      onClick={() => this.copyToClipboard(this.state.courseKey)}
                    >
                      {i18n.t("base.copy")}
                    </VstButton>
                  )}
                </VstInputGroup.Button>
              </VstInputGroup>
            )}
          </div>
        </div>
        {this.state.ancillary.href && (
          <div className="footer-actions">
            <button onClick={() => this.visitWebSite()}>
              {i18n.t("eresources.visit-website")}
            </button>
          </div>
        )}
      </div>
    );
  }

  renderCurrentStep() {
    if (this.state.waiting) {
      return <VstLoader />;
    }

    if (this.state.error) {
      return <div>{i18n.t("messages.500-error")}</div>;
    }

    switch (this.state.step) {
      case 1:
        return this.revealAccessCode();
      case 2:
        return this.showAccessCode();
      default:
        return this.initialInfo();
    }
  }

  render() {
    return <div id="reveal-courseware">{this.renderCurrentStep()}</div>;
  }
}

AccessCodeModal.propTypes = {};

module.exports = AccessCodeModal;
